import { createFileRoute, Outlet } from '@tanstack/react-router'
import Footer from '@web/src/features/footer/footer'
import { useFooterLayoutStaticData } from '@web/src/features/footer/footer-layout-static-data'
import MainNavBar from '@web/src/features/main-nav-bar/main-nav-bar'

export const Route = createFileRoute('/(auth)/(main-layout)')({
  component: Layout,
})

function Layout() {
  const { hideFooter } = useFooterLayoutStaticData()

  return (
    <>
      <MainNavBar />
      <Outlet />
      {!hideFooter && <Footer />}
    </>
  )
}
